const STORAGE_PREFIX = 'compliance-v2:activeTenant:';

export function activeTenantStorageKey(userId: number): string {
  return `${STORAGE_PREFIX}${userId}`;
}

export function readStoredActiveTenantId(userId: number | null | undefined): number | null {
  if (!userId) {
    return null;
  }
  const raw = localStorage.getItem(activeTenantStorageKey(userId));
  if (!raw) {
    return null;
  }
  const parsed = Number(raw);
  return Number.isFinite(parsed) && parsed > 0 ? parsed : null;
}

export function writeStoredActiveTenantId(userId: number, tenantId: number | null): void {
  const key = activeTenantStorageKey(userId);
  if (!tenantId) {
    localStorage.removeItem(key);
    return;
  }
  localStorage.setItem(key, String(tenantId));
}

let runtimeActiveTenantId: number | null = null;

export function getRuntimeActiveTenantId(): number | null {
  return runtimeActiveTenantId;
}

export function setRuntimeActiveTenantId(tenantId: number | null): void {
  runtimeActiveTenantId = tenantId;
}

export function resolveActiveTenantHeader(userId: number | null | undefined): string | undefined {
  const tenantId = runtimeActiveTenantId ?? readStoredActiveTenantId(userId);
  return tenantId ? String(tenantId) : undefined;
}
